/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";
import React from "react";

export const ContractRowSkeletonMobile = (props) => (
    <ContentLoader
        width={"100%"}
        height={200}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{backgroundColor: "#fff", borderRadius: "4px", marginBottom: "12px"}}
        {...props}>

        {/* Contract number */}
        <rect x="16" y="16" rx="3" ry="3" width="25%" height="10"/>
        <rect x="16" y="36" rx="3" ry="3" width="25%" height="10"/>

        {/* Remaining quantity */}
        <rect x="16" y="40%" rx="3" ry="3" width="25%" height="10"/>
        <rect x="16" y={`calc(40% + 20px)`} rx="3" ry="3" width="40%" height="10"/>

        {/* Valid from - until */}
        <rect x="50%" y="40%" rx="3" ry="3" width="25%" height="10"/>
        <rect x="50%" y={`calc(40% + 20px)`} rx="3" ry="3" width="40%" height="10"/>

        {/* View more */}
        <rect x="5%" y={`calc(100% - 50px)`} rx="3" ry="3" width="90%" height="30"/>

    </ContentLoader>
);
